"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionTypes = void 0;
var permissionTypes = function (permission, permissions) {
    var _a;
    var userPermissions = permissions;
    return (_a = userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.includes(permission)) !== null && _a !== void 0 ? _a : false;
};
exports.permissionTypes = permissionTypes;
